import { render, staticRenderFns } from "./SubmitStatements.vue?vue&type=template&id=7537042b&scoped=true&"
import script from "./SubmitStatements.vue?vue&type=script&lang=js&"
export * from "./SubmitStatements.vue?vue&type=script&lang=js&"
import style0 from "./SubmitStatements.vue?vue&type=style&index=0&id=7537042b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537042b",
  null
  
)

export default component.exports